import { render, staticRenderFns } from "./Logomain.vue?vue&type=template&id=b52f0e58&"
import script from "./Logomain.vue?vue&type=script&lang=js&"
export * from "./Logomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports